/**
 * У��Ȩ��
 * @param token
 * @returns {*}
 */
export function authorization(code) {
    let permissionList = JSON.parse(sessionStorage.getItem("permissionList"));
    let permission = permissionList.find((x) => { return x.code == code; });
    return permission?.id > 0;
}